<template>
  <div id="skill-page">
    <h1 style="margin: 20px">
      {{
      skill.localizedTitle.lt
      }}
    </h1>
    <table style="margin: 0 auto">
      <tr v-for="pro in pros" v-bind:key="pro.id">
        <td style="text-align: left">{{ pro.serviceArea.code }}</td>
        <td style="text-align: left">{{ pro.serviceArea.text }}</td>
        <td style="text-align: left">{{ pro.serviceArea.radius / 1000 }}km</td>
        <td style="text-align: left"><router-link :to="{ name: 'userProfile', params: { id: pro.id } }">{{pro.firstName + ' ' + pro.lastName}}</router-link></td>
        <td>{{ pro.skillSettings && pro.skillSettings[skill.id] ? Number(pro.skillSettings[skill.id].rate / 100 / 0.8).toFixed(2) : '?' }}</td>
        <td>{{ pro.ordersDisabled ? 'DISABLED' : '' }}:{{ pro.proType === 'business' && pro.businessSkills && pro.businessSkills.indexOf(skill.id) !== -1 ? 'business' : '' }}{{!pro.availabilityConfig && pro.proType === 'business' ? ':NOCAL' : ''}}</td>
      </tr>
    </table>

    <div>
      <table style="margin: 0 auto;margin-top: 20px">
        <tr>
          <td>
            <label>Service</label>
          </td>
          <td>
            <select v-model="serviceId">
              <option
                v-bind:key="service.id"
                v-for="service in services"
                v-bind:value="service.id"
              >{{service.localizedTitle.lt}}</option>
            </select>
          </td>
        </tr>
        <tr>
          <td>
            <label>Translation ID</label>
          </td>
          <td>
            <input :disabled="$route.params.id != 'new'" type="text" v-model="title" />
          </td>
        </tr>
        <tr>
          <td>
            <label>LT Title</label>
          </td>
          <td>
            <input type="text" v-model="ltTitle" />
          </td>
        </tr>
        <tr>
          <td>
            <label>EN Title</label>
          </td>
          <td>
            <input type="text" v-model="enTitle" />
          </td>
        </tr>
        <tr>
          <td>
            <label>PL Title</label>
          </td>
          <td>
            <input type="text" v-model="plTitle" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Hidden</label>
          </td>
          <td>
            <input type="checkbox" id="checkbox" v-model="hidden" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Card Image</label>
          </td>
          <td>
            <input type="text" v-model="image" />
            <div>336x240 stored /skills/{skillId}/</div>
          </td>
        </tr>
        <tr>
          <td>
            <label>Cover Image</label>
          </td>
          <td>
            <input type="text" v-model="imageCover" />
            <div>1280x600 stored /skills/{skillId}/</div>
          </td>
        </tr>
        <tr>
          <td>
            <label>Sort priority</label>
          </td>
          <td>
            <input type="text" v-model="sortPriority" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Business Rate without fee LT EUR</label>
          </td>
          <td>
            <input type="text" v-model="hourlyRate" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Business Rate without fee PL PLN</label>
          </td>
          <td>
            <input type="text" v-model="hourlyRatePl" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Minimum rate LT EUR</label>
          </td>
          <td>
            <input type="text" v-model="minRate" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Rate limit</label>
          </td>
          <td>
            <input type="text" v-model="rateLimit" />
          </td>
        </tr>
        <tr>
          <td>
            <label>LT Short Description</label>
          </td>
          <td>
            <input type="text" v-model="ltShortDescription" />
          </td>
        </tr>
        <tr>
          <td>
            <label>EN Short Description</label>
          </td>
          <td>
            <input type="text" v-model="enShortDescription" />
          </td>
        </tr>
        <tr>
          <td>
            <label>PL Short Description</label>
          </td>
          <td>
            <input type="text" v-model="plShortDescription" />
          </td>
        </tr>
        <tr>
          <td>
            <label>LT Full Description</label>
          </td>
          <td>
            <textarea v-model="ltFullDescription" />
          </td>
        </tr>
        <tr>
          <td>
            <label>EN Full Description</label>
          </td>
          <td>
            <textarea v-model="enFullDescription" />
          </td>
        </tr>
        <tr>
          <td>
            <label>PL Full Description</label>
          </td>
          <td>
            <textarea v-model="plFullDescription" />
          </td>
        </tr>
      </table>

      <button
        v-on:click="updateRateStats()"
        style="background-color: #333;color: white; padding:10px;cursor:pointer;margin-top:20px"
      >Update skill</button>
    </div>
  </div>
</template>

<style scoped lang="less">
#skill-page {
  input {
    padding: 10px;
  }
  table {
    td {
      border: 1px solid #999;
      border-collapse: collapse;
      margin: 0;
      padding: 10px;
    }
  }
}
</style>

<script>
import * as storeReader from "../services/storeReader";
import api from "../services/api";
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: "home",
  data: function () {
    return {
      storeReader,
      user: null,
      pros: []
    };
  },
  methods: {
    updateRateStats: async function () {
      const getSkillData = () => {
        const stats = {
          minimum: { EUR: parseInt(this.minRate) },
          limit: { EUR: parseInt(this.rateLimit) },
          from: { EUR: parseInt(this.fromRate) },
        };
        return {
          priceStats: stats,
          title: this.title,
          serviceId: this.serviceId,
          sortPriority: this.sortPriority,
          image: this.image,
          imageCover: this.imageCover,
          hidden: this.hidden,
          hourlyRate2: {
            LT: {
              EUR: this.hourlyRate
            },
            PL: {
              PLN: this.hourlyRatePl
            }
          },
          info: {
            shortDescription: {
              lt: this.ltShortDescription,
              en: this.enShortDescription,
              pl: this.plShortDescription
            },
            fullDescription: {
              lt: this.ltFullDescription,
              en: this.enFullDescription,
              pl: this.plFullDescription,
            },
          },
        };
      };
      const getTranslationsData = () => {
        return this.ltTitle
          ? {
              [this.title]: {
                en: this.enTitle,
                lt: this.ltTitle,
                pl: this.plTitle,
              },
            }
          : {};
      };
      const data = getSkillData();
      const translations = getTranslationsData();
      let id = this.skill.id;
      if (this.$route.params.id == "new") {
        const response = await api.createSkill(data, translations);
        id = response.id;
      } else {
        await api.updateSkill(this.skill.id, data, translations);
      }
      await this.$store.commit(
        "updateSkill",
        Object.assign({ id, translations }, data)
      );
      this.$router.push({ name: "skills" }).catch(() => {});
    },
  },
  created: async function () {
    const id = this.$route.params.id;
    const state = this.$store.state;
    this.services = state.services;
    this.skill = state.skills[id] || { priceStats: {}, localizedTitle: {} };
    this.skillStats = Object.assign(
      { minimum: { EUR: 0 }, limit: { EUR: 10000 }, from: { EUR: 0 } },
      this.skill.priceStats
    );
    this.rateLimit = this.skillStats.limit.EUR;
    this.minRate = this.skillStats.minimum.EUR;
    this.image = this.skill.image;
    let hourlyRate = Object.assign({LT: {EUR: 0 }, PL: {PLN: 0}}, this.skill.hourlyRate2 || {});
    this.hourlyRate = hourlyRate.LT.EUR;
    this.hourlyRatePl = hourlyRate.PL.PLN;
    this.imageCover = this.skill.imageCover;
    this.hidden = this.skill.hidden;
    this.serviceId = this.skill.serviceId || "";
    this.title = this.skill.title || "";
    const trans = this.skill.localizedTitle || {};
    this.enTitle = trans.en;
    this.ltTitle = trans.lt;
    this.plTitle = trans.pl;
    this.enShortDescription =
      (this.skill.info &&
        this.skill.info.shortDescription &&
        this.skill.info.shortDescription.en) ||
      "";
    this.ltShortDescription =
      (this.skill.info &&
        this.skill.info.shortDescription &&
        this.skill.info.shortDescription.lt) ||
      "";
    this.plShortDescription =
      (this.skill.info &&
        this.skill.info.shortDescription &&
        this.skill.info.shortDescription.pl) ||
      "";
    this.enFullDescription =
      (this.skill.info &&
        this.skill.info.fullDescription &&
        this.skill.info.fullDescription.en) ||
      "";
    this.ltFullDescription =
      (this.skill.info &&
        this.skill.info.fullDescription &&
        this.skill.info.fullDescription.lt) ||
      "";
    this.plFullDescription =
      (this.skill.info &&
        this.skill.info.fullDescription &&
        this.skill.info.fullDescription.pl) ||
      "";
    this.sortPriority = this.skill.sortPriority || 0;
    console.log(this.skill);
    const pros = await api.getPros();
    this.pros = Object.values(pros)
      .filter((u) => (((u.skills || []).indexOf(id) !== -1 || (u.businessSkills || []).indexOf(id) !== -1)) && u.verified)
      .sort((a, b) => {
        // if (a.skillSettings && a.skillSettings[id] && b.skillSettings && b.skillSettings[id]) {
          return a.serviceArea.text > b.serviceArea.text;
        // }
      });
    // console.log(this.user);
    this.fromRate = this.pros.length
      ? this.pros[0].skillSettings[id].rate / 0.8
      : 0;
    console.log(this.fromRate);
  },
};
</script>
